import * as _ from 'lodash';
import { RegentsExam } from './regents.constant';

export const DiscontinuedRegentsExamKeys = _.map(_.filter(RegentsExam, { isOffered: false }), 'key');
